import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PhoneCallbackIcon(props: IconProps) {
    return <Icon {...props} iconKey={"phone_callback"}/>
}
